import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  TasksList,
} from './styles';
import ListItem from './ListItem';

const ClientOfferTasks = () => {
  const [t] = useTranslation();

  return (
    <TasksList>
      <ListItem
        isActive={false}
        isActiveLine={false}
        isDone={false}
        title={t('CLIENT_OFFER_STAGE_TITLE_1', { numberOfHours: 'XX' })}
      />

      <ListItem
        isActive={false}
        isActiveLine={false}
        isDone={false}
        title={t('CLIENT_OFFER_STAGE_TITLE_2')}
      />
    </TasksList>
  )
}

export default React.memo(ClientOfferTasks);